import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Grid,
  LinearProgress,
  Tooltip
} from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';

interface RiskIndicator {
  name: string;
  value: number;
  description: string;
  threshold: number;
}

const mockIndicators: RiskIndicator[] = [
  {
    name: 'Attendance Pattern',
    value: 75,
    description: 'Based on recent attendance trends and historical patterns',
    threshold: 85
  },
  {
    name: 'Academic Progress',
    value: 65,
    description: 'Combines GPA, course completion, and grade trends',
    threshold: 70
  },
  {
    name: 'Behavioral Indicators',
    value: 90,
    description: 'Based on disciplinary records and teacher feedback',
    threshold: 80
  },
  {
    name: 'Engagement Score',
    value: 82,
    description: 'Measures participation in school activities and counseling sessions',
    threshold: 75
  }
];

export const PredictiveIndicators: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Early Warning Indicators
      </Typography>

      <Grid container spacing={3}>
        {mockIndicators.map((indicator) => (
          <Grid item xs={12} key={indicator.name}>
            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle1" sx={{ mr: 1 }}>
                  {indicator.name}
                </Typography>
                <Tooltip title={indicator.description}>
                  <InfoIcon fontSize="small" color="action" />
                </Tooltip>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flexGrow: 1, mr: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={indicator.value}
                    color={indicator.value < indicator.threshold ? "warning" : "success"}
                    sx={{ height: 8, borderRadius: 4 }}
                  />
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {indicator.value}%
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};